import { pushFaqEvent } from '@utils/dataLayer';
import { getAnalyticsSection, getDecanterPageProductMeta } from '@utils/analyticsContext';

const initFaqAccordion = () => {
  const accordions = document.querySelectorAll('[data-faq-accordion]');

  accordions.forEach((accordion) => {
    const items = Array.from(accordion.querySelectorAll('details.faq__item'));

    if (items.length <= 1) return;

    const openedItems = items.filter((item) => item.hasAttribute('open'));
    openedItems.slice(1).forEach((item) => {
      item.removeAttribute('open');
    });

    const getItemLabel = (item) => {
      const summary = item.querySelector('summary');
      return summary ? summary.textContent.trim() : '';
    };

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((otherItem) => {
          if (otherItem === item) return;
          otherItem.removeAttribute('open');
        });

        const label = getItemLabel(item);
        const productMeta = getDecanterPageProductMeta();

        pushFaqEvent({
          section: getAnalyticsSection() || document.title || '',
          label,
          name: productMeta.name,
          id: productMeta.id,
          collectionName: productMeta.collectionName,
        });
      });
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-faq', () => {
      initFaqAccordion();
    });
  } else {
    initFaqAccordion();
  }
});
